import { z } from 'zod'
import { oc } from '@orpc/contract'

export const feePolicySchema = z.object({
  credentialPercent: z.object({
    MD: z.number().min(0).max(200).nullable(),
    DO: z.number().min(0).max(200).nullable(),
    NP: z.number().min(0).max(200).nullable(),
    PA: z.number().min(0).max(200).nullable(),
    RN: z.number().min(0).max(200).nullable(),
  }),
  /** Flat self-pay visit fee, cents (PD-1943). */
  selfPayVisitFeeCents: z.number().int().min(0),
})

// The fee policy of the organization the caller acts for (PD-1597); the
// built-in default when none is stored.
export const billingFeePolicyGet = oc
  .route({ method: 'GET', path: '/v2/billing/fee-policy' })
  .input(z.object({}).optional())
  .output(
    z.object({
      organizationId: z.string().nullable(),
      policy: feePolicySchema,
      stored: z.boolean(),
    }),
  )

// Super-admin only until the Billing Manager role lands: replaces the caller
// organization's fee policy.
export const superSetFeePolicy = oc
  .route({ method: 'PUT', path: '/v2/super/fee-policy' })
  .input(feePolicySchema)
  .output(z.object({ organizationId: z.string(), policy: feePolicySchema }))

// Super-admin only: loads the PD-1597 initial adult charge schedule (MD/DO base +
// NP/PA amount per code) onto the caller organization's procedure catalog,
// merging by code. The catalog must already exist (Settings › Terminology).
export const superSeedFeeSchedule = oc
  .route({ method: 'POST', path: '/v2/super/fee-schedule/seed' })
  .input(z.object({}).optional())
  .output(
    z.object({
      organizationId: z.string(),
      codes: z.number(),
      added: z.number(),
      updated: z.number(),
    }),
  )
